import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-not-auth-header',
  templateUrl: './not-auth-header.component.html',
  styleUrls: ['./not-auth-header.component.css']
})
export class NotAuthHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
